  import { Injectable } from '@angular/core';
  import { io, Socket, SocketOptions, ManagerOptions } from 'socket.io-client';
  // import { NetworkManagementService } from './network-management.service';
  import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

  export type EventHandlers = { [evt: string]: (params: any) => void }

  @Injectable({
    providedIn: 'root'
  })
  export class WebsocketService {
    
    private webSocket: Socket | null = null;
    private connectIfPossible = false;
    private isConnected = false;
    
    public socketEventHandlers: EventHandlers = {
      connect: () => {
        console.log('Socket is created');
        this.isConnected = true;
      },
      connect_error: (e: any) => {
        console.log(`Error in Socket ${JSON.stringify(e)}`);
        // this.closeConnection();
        this.isConnected = false;
      },
      disconnect: () => {
        console.log('Socket is disconnected');
        this.closeConnection();
        this.isConnected = false;
      }
    };

    constructor( private Api: AuthService) { }

    createWebSocketConnection = () => {

      const token = this.Api.Token;
      const sockOptions: SocketOptions | ManagerOptions = {
        query: {},
        auth: { token, transports: ['websocket'] },//, 'polling', 'flashsocket'
        autoConnect: false,
      };
     
      this.webSocket = io(environment.apiBaseUrl, sockOptions);
      

      for (let evh in this.socketEventHandlers) {
        // console.log('socketEventHandlers', evh);
        this.webSocket.on(evh, this.socketEventHandlers[evh]);
      }
      // Connect to the WebSocket server
      this.webSocket.connect();
    };

    closeConnection = () => {
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
    };

    // Method to send a message to the WebSocket server
    sendMessage = (topic: string, data: any) => {
      if (this.webSocket) {
        this.webSocket.emit(topic, data);
      }
    }

    // Method to set or update event handlers for WebSocket events
    setEventHandlers = (
      handlerFunctions: EventHandlers,
      clearPreviousHandlers = false
    ) => {

      // Validate event handler functions
      for (let evh of Object.keys(handlerFunctions)) {
        if (typeof handlerFunctions[evh] !== 'function') {
          throw `Invalid or incorrect event handlers`;
        }
      }
      
       // Update or replace event handlers
      if (clearPreviousHandlers) {
        this.socketEventHandlers = handlerFunctions;
      } else {
        this.socketEventHandlers = {
          ...this.socketEventHandlers,
          ...handlerFunctions,
        };
      }
    };

    // Getter for connection status
    public get IsConnected() {
      return this.isConnected;
    }

     // Getter and setter for connection attempt flag
    public get ConnectIfPossible() {
      return this.connectIfPossible;
    }
    public set ConnectIfPossible(val: boolean) {
      this.connectIfPossible = val;
    }
  }
